import type { QueryClient } from '@tanstack/react-query'
import { getGetOrganizationSubdomainQueryKey } from '@/api/generated/organization/organization'

/**
 * Refreshes every cached copy of the salon web address status (address, live, changes left, old links).
 * Business Details keys it by the route short code and the Bio Page editor by the org id, so this matches the
 * bare Orval path prefix. Call after anything that renames the address or makes it public (Bio Page or
 * campaign publish, agency grant).
 */
export function invalidateWebAddressStatus(queryClient: QueryClient) {
  return queryClient.invalidateQueries({ queryKey: [...getGetOrganizationSubdomainQueryKey()] })
}

/** Orval path prefixes of screens that show links built on the salon web address (label + domain). */
const SALON_LINK_QUERY_PREFIXES = ['/marketing', '/link-bio', '/new-client-offer', '/referrals', '/creators', '/prizes', '/check-in']

/**
 * After the web address (label or domain) changes, refreshes the screens that show links on it — campaigns,
 * Bio Page, offer, referral, creator, prize and check-in poster links — so none keeps showing the old address
 * until its own refetch. Old links still work (they redirect); this is about what the owner copies next.
 */
export function invalidateSalonLinkQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    predicate: ({ queryKey }) => {
      const path = queryKey[0]
      return typeof path === 'string' && SALON_LINK_QUERY_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))
    },
  })
}
